<!-- =========================================================================================
    File Name: KnowledgeBase.vue
    Description: Knowledge Base Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vx-card class="cursor-pointer">
      <img :src="data.image_path" alt="graphic" class="mx-auto mb-4 responsive" v-if="data.image_path">
      <h4 class="mb-2">{{ data.name.toUpperCase() }}</h4>
      <small class="text-center">{{$t('helpCenter.groupDesc', [data.name])}}</small>

      <ul class="bordered-items mt-4" v-if="showArticles">
          <li v-for="que in data.articles" :key="que.slug" class="py-2" @click="onClickArticle(que)">
            {{que.title}}
          </li>
      </ul>
  </vx-card>
</template>

<script>

export default{
  props: {
    data: {
      default: {}
    },
    showArticles: {
      type: Boolean,
      default: true
    },
    isPublic: {
      type: Boolean,
      default: false
    }
  },
  name: 'help-center-group-component',
  methods: {
    onClickArticle(article){
      if('slug' in article){
        let routeData = this.$router.resolve({
          name: this.isPublic ? 'public-help-center-article' : 'customer-help-center-article',
          params: {
            slug: article.slug,
            data: article
          }
        })
        window.open(routeData.href, '_blank')
      }
    },
    onClickGroup(){
      this.$router.push({
        name: this.isPublic ? 'public-help-center-group' : 'customer-help-center-group',
        params: {
          id: this.data.id,
        }
      })
    },
  }
}
</script>
